import { ContentWrapper } from "../components/design-system/ContentWrapper";
import { CardButton } from "../components/design-system/CardButton";
import { useCreditCardState } from "../hooks/useCreditCardState";
import { useCallback, useState } from "react";
import { Navigation } from "../components/Navigation";
import { useCardModal } from "../hooks/useCardModal";
import { useShareModal } from "../hooks/useShareModal";
import { CardComboTemplates } from "../components/CardComboTemplates";
import { CreditCardSearchBar } from "../components/CreditCardSearchBar";
import { RewardsCardPreviews } from "./RewardsEstimator";
import { CreditCard } from "../data/shared/CreditCard";
import { CreditCardData } from "data/shared/CreditCardData";
import { FooterContent } from "components/FooterContent";
import { PopularCards } from "../components/PopularCards";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const HomePage = () => {
  const [selectedCards, setSelectedCards] = useCreditCardState();

  const handleRemoveCard = useCallback(
    (cardToRemove: CreditCard) => {
      setSelectedCards((currentCards: CreditCard[]) =>
        currentCards.filter((card) => card !== cardToRemove)
      );
    },
    [setSelectedCards]
  );

  const handleAddCard = useCallback(
    (newCard: CreditCard) => {
      setSelectedCards((currentCards: CreditCard[]) => {
        if (currentCards.find((card) => card === newCard)) {
          return currentCards;
        }
        return [...currentCards, newCard];
      });
    },
    [setSelectedCards]
  );

  const [cardModal, setShowCardModal] = useCardModal(handleRemoveCard);
  const [shareModal, showShareModal] = useShareModal();

  return (
    <div style={{ position: 'relative' }}>
      {shareModal}
      <Navigation />

      <ContentWrapper style={{ position: 'relative' }}>
        <div
          style={{
            maxWidth: 600,
            margin: '0 auto',
          }}
        >
          <h1
            style={{
              fontSize: 64,
              lineHeight: 1.1,
              textAlign: 'center',
              position: 'relative',
            }}
          >
            Wallet optimizer
            <p
              style={{
                fontFamily: 'monospace',
                position: 'absolute',
                top: 0,
                right: -10,
                fontSize: 12,
                color: 'white',
                backgroundColor: '#6488A3',
                padding: 5,
                borderRadius: 5,
              }}
            >
              BETA
            </p>
          </h1>
          <p>
            All credit cards have strengths and weaknesses. Use the table below
            to always get the best rewards for your wallet.
          </p>
        </div>
        <div
          style={{
            position: 'relative',
            maxWidth: 800,
            margin: '0 auto',
          }}
        >
          <PopularCards
            onAddCard={handleAddCard}
            onRemoveCard={handleRemoveCard}
            selectedCards={selectedCards}
          />
          <CreditCardSearchBar
            handleAddCard={handleAddCard}
            handleRemoveCard={handleRemoveCard}
            selectedCards={selectedCards}
            setSelectedCards={setSelectedCards}
          />
        </div>
        <div style={{ margin: '20px auto', position: 'sticky', top: 0 }}>
          <CardComboTemplates
            setSelection={setSelectedCards}
            selectedCards={selectedCards}
          />
        </div>

        <div
          style={{
            zIndex: -1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#fff',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: -200,
            left: 0,
            right: 0,
            height: 400,
            zIndex: -1,
            background: 'linear-gradient(#fff, #eef1f4)',
          }}
        ></div>
      </ContentWrapper>

      <div>
        <div
          style={{ display: 'flex', flexDirection: 'row', gap: 10, margin: 20 }}
        >
          {selectedCards.length ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ padding: '8px 12px' }}>
                Selected cards <br />({selectedCards.length}):{' '}
              </h3>
              {selectedCards.map((card) => {
                return (
                  <div style={{ display: 'flex', flexDirection: 'row',  justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <CardButton
                      cardData={CreditCardData[card]}
                      onClick={() => setShowCardModal(card)}
                    />
                    <button style={{ marginTop: 35 }} onClick={() => handleRemoveCard(card)}><FontAwesomeIcon icon={faXmark} /></button>
                  </div>
                );
              })}
            </div>
          ) : null}
          <div
            style={{
              flexGrow: 1,
              backgroundColor: '#fff',
              borderRadius: 30,
              padding: 20,
              overflowX: 'auto',
              alignSelf: 'flex-start',
            }}
          >
            <RewardsCardPreviews
              cards={selectedCards}
              handleRemoveCard={handleRemoveCard}
              handleAddCard={handleAddCard}
              setSelectedCards={setSelectedCards}
            />
          </div>
        </div>
        {cardModal}
      </div>
      <ContentWrapper>
        <FooterContent />
      </ContentWrapper>
    </div>
  );
};